/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextActionPlusIcon16Light } from './TextActionPlusIcon16Light';
import { TextActionPlusIcon16Regular } from './TextActionPlusIcon16Regular';
import { TextActionPlusIcon16Solid } from './TextActionPlusIcon16Solid';
import { TextActionPlusIcon20Light } from './TextActionPlusIcon20Light';
import { TextActionPlusIcon20Regular } from './TextActionPlusIcon20Regular';
import { TextActionPlusIcon20Solid } from './TextActionPlusIcon20Solid';
import { TextActionPlusIcon24Regular } from './TextActionPlusIcon24Regular';
import { TextActionPlusIcon24Solid } from './TextActionPlusIcon24Solid';
import { TextActionPlusIcon32Regular } from './TextActionPlusIcon32Regular';
import { TextActionPlusIcon64Regular } from './TextActionPlusIcon64Regular';
var sizes = {
    16: {
        light: TextActionPlusIcon16Light,
        regular: TextActionPlusIcon16Regular,
        solid: TextActionPlusIcon16Solid,
    },
    20: {
        light: TextActionPlusIcon20Light,
        regular: TextActionPlusIcon20Regular,
        solid: TextActionPlusIcon20Solid,
    },
    24: {
        regular: TextActionPlusIcon24Regular,
        solid: TextActionPlusIcon24Solid,
    },
    32: {
        regular: TextActionPlusIcon32Regular,
    },
    64: {
        regular: TextActionPlusIcon64Regular,
    },
};
export var TextActionPlusIcon = forwardRef('TextActionPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
